import React, { useState, useEffect, useCallback, useRef } from 'react';
import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';

// Material-UI Core Components
import {
    withStyles,
    makeStyles,
    createTheme
} from '@material-ui/core/styles';
import {
    IconButton,
    InputAdornment,
    Typography,
    Box,
    Chip,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
// Material-UI DataGrid
import { DataGrid, esES } from '@material-ui/data-grid';

// Material-UI Icons
import { Visibility, VisibilityOff, Close, Nfc, PersonOutline, CheckCircleOutline } from '@material-ui/icons';

// External Libraries
import Cookies from 'universal-cookie';

// Components NOVA
import Llamados from '../../components/Llamados/Llamados';
import ActionToast from '../../components/ActionToast/ActionToast';

const defaultTheme = createTheme();

const useStyles = makeStyles(
    (theme) => ({
        root: {
            [theme.breakpoints.down('sm')]: {
                height: 150,
                '& .MuiDataGrid-root': {
                    maxHeight: 120, 
                },
            },
            [theme.breakpoints.up('md')]: {
                height: 200,
                '& .MuiDataGrid-root': {
                    maxHeight: 200, 
                },
            },
            [theme.breakpoints.up('lg')]: {
                height: 270,
                '& .MuiDataGrid-root': {
                    maxHeight: 243,
                    '& .MuiDataGrid-viewport': {
                        maxHeight: '183px !important', 
                    },
                },
            },
            [theme.breakpoints.up('xl')]: {
                height: 337,
                '& .MuiDataGrid-root': {
                    maxHeight: 253, 
                },
            },
            [theme.breakpoints.up('xxl')]: {
                height: 337,
                '& .MuiDataGrid-root': {
                    maxHeight: 253, 
                },
            },
            width: '100%',
            overflow: 'auto',
        },
        label: {
            marginTop: theme.spacing(1),
            textAlign: 'center',
            fontSize: '26px',
            fontWeight: 600,
            fontFamily: 'WorkSans',
            letterSpacing: '0px',
            opacity: 1,
        },
    }),
    { defaultTheme }
);

const YellowChip = withStyles({
    root: { backgroundColor: '#f8eab7', color: '#000' },
    clickable: {},
})((props) => <Chip color="default" {...props} />);

const RedChip = withStyles({
    root: { backgroundColor: '#FCCACD', color: '#000' },
    clickable: {},
})((props) => <Chip color="default" {...props} />);

const GreenChip = withStyles({
    root: { backgroundColor: '#95FCDE', color: '#000' },
    clickable: {},
})((props) => <Chip color="default" {...props} />);

export default function TablaANDON() {
    const classes = useStyles();
    const [seleccionFila, setSeleccionFila] = useState([]);

    const cookie = new Cookies();
    const linea = parseInt(cookie.get('linea'));

    const [rowsANDON, setRowsANDON] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [, setElapsedTime] = useState(0);
    const [open, setOpen] = useState(false);
    const [openFinalizar, setOpenFinalizar] = useState(false);
    const [dialogStep, setDialogStep] = useState(1);
    const [comentario, setComentario] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);
    const [mensaje , setMensaje] = useState('');
    const [tipoMensaje , setTipoMensaje] = useState('success');
    const [openSnack, setOpenSnack] = useState(false);

    const [categorias, setCategorias] = useState([]); 
    const [selectedOption1, setSelectedOption1] = useState(''); 
    const [selectedOption2, setSelectedOption2] = useState(''); 
    const [fallasFiltradas, setFallasFiltradas] = useState([]);
    const [, setFallas] = useState([]);


    const [auth, setAuth] = useState(false);
    const [, setAuthFinalizar] = useState(false);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false); 
    const [usernameError, setUsernameError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [, setQuienAtiende] = useState(''); 
    const [idLlamada, setIdLlamada] = useState(null);

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [, setButtonLabel] = useState('Atender');
    const [, setError] = useState(null);
    const [, setButtonStates] = useState({});
    // Controla si se muestra el formulario de contraseña o la pantalla RFID
    const [showPasswordForm, setShowPasswordForm] = useState(false);

    // Refs para el hub de Atender/Finalizar
    const llamadasHubRef = useRef(null);
    const dialogHandlerRef = useRef(null);


    const handleFlujoLoginYAtender = async () => {
        try {
            setIsButtonDisabled(true);
            setButtonLabel('Procesando...');
            setShowPasswordForm(false);
            setOpen(true);
        } catch (err) {
            setError(err.message || 'Error al procesar la solicitud.');
        }
    };

    const handleFlujoLoginFinalizar = async () => {
        try {
            setIsButtonDisabled(true);
            setButtonLabel('Procesando...');
            setShowPasswordForm(false);
            setOpenFinalizar(true);
        } catch (err) {
            setError(err.message || 'Error al procesar la solicitud.');
        }
    };
    
    // Función para convertir fechas a hora local correctamente
    const parseDateToLocal = useCallback((dateString) => {
        if (!dateString) return null;
        
        // Si la fecha ya tiene zona horaria, usar Date.parse directamente
        if (dateString.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(dateString)) {
            return new Date(dateString);
        }
        // Si no tiene zona horaria, tratarla como hora local (no agregar Z)
        // new Date() interpreta strings sin zona horaria como hora local
        return new Date(dateString);
    }, []);

    const filtrarDatos = useCallback((data) => {
        if (!Array.isArray(data)) {
            return [];
        }
        return data.map((item, index) => ({
            id: item.llamada1 ?? `row-${index}`,
            areaAtencion: item.areaAtencion,
            codigoArea: item.codigoArea,
            inicialesArea: item.inicialesArea,
            colorArea: item.color,
            nombre: item.nombre,
            estatus: item.estatus,
            nivel: item.nivel,
            fechaHoraInicio: parseDateToLocal(item.fechaHoraInicio), 
            fechaHoraRespuesta: parseDateToLocal(item.fechaHoraRespuesta), 
            tiempoRespuesta: item.tiempoRespuesta,
            tiempoReparacion: item.tiempoReparacion, // tiempoReparacion viene en segundos, no es una fecha
            estatusText: item.estatusText,
            requiereClasificacion: item.requiereClasificacion,
            solicita: item.solicita,
            atiende: item.atiende,
            tipoLlamada: item.tipoLlamada,
        }));
    }, [parseDateToLocal]);

    async function LoginUser(credentials) {
        const response = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/usuarios/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(credentials),
        });

        if (!response.ok) {
            throw new Error('Error en la autenticación. Verifica tus credenciales.');
        }

        const data = await response.json();
        return data.token;
    }

    async function fetchUserInfo(nombreUsuario, token) {
        if (!token) {
            throw new Error('Token no proporcionado. Verifica tu sesión.');
        }
    
        const response = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/usuarios/GetUsuario?username=${encodeURIComponent(nombreUsuario)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
    
        if (!response.ok) {
            if (response.status === 401) {
                throw new Error('No autorizado. Verifica tu token de autenticación.');
            }
            throw new Error('Error al obtener la información del usuario.');
        }
    
        const data = await response.json();
        const { nombre, apellido } = data;
        return { nombre, apellido };
    }

    const handleAtender = async (idLlamada, quienAtiende) => {
        try {
            
            if (!quienAtiende) {
                throw new Error('El usuario que atiende no está definido.');
            }

            const response = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Llamadas/LlamadaAtendida`, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    idLlamada,
                    quienAtiende,
                }),
            });

            if (!response.ok) {
                throw new Error('Error al procesar la solicitud.');
            }

            if (auth === true) {
                setButtonStates((prevState) => ({
                    ...prevState,
                    [idLlamada]: 'Finalizar',
                }));
            }
        } catch (err) {
            setError(err.message || 'Error al atender la llamada.');
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        let loginError = '';

        if (username === '' || password === '') {
            if (username === '') setUsernameError(true);
            if (password === '') setPasswordError(true);
            return;
        }
        
        if (open){
        try {
            const token = await LoginUser({ usuario: username, password });
            if (token) {
                setAuth(true);
    
                const userData = await fetchUserInfo(username, token);
                setQuienAtiende(`${userData.nombre} ${userData.apellido}`);
                await handleAtender(idLlamada, username);                
                setAuth(false);
                setOpen(false);
                setUsername('');
                setPassword('');
                setUsernameError(null);
                setPasswordError(null);
                setMensaje('Se inicia reparación');
                setTipoMensaje('success');
                setOpenSnack(true);
                setTimeout(() => fetchLlamadasActivas(true), 500);
            }
        } catch (err) {
            loginError = err.message || 'Error al autenticar. Inténtalo de nuevo.';
    
            if (err.response && err.response.data) {
                const { message } = err.response.data;
                loginError = message || loginError;
                setUsernameError(message);
                setPasswordError(message);
            }
        } finally {
            setIsButtonDisabled(false); 
        }
        setError(loginError);
        } else if (openFinalizar) {
            try {
                const token = await LoginUser({ usuario: username, password });
                if (token) {
                    setAuthFinalizar(true);
                    setDialogStep(2);
                    return; 
                }
            } catch (err) {
                let loginError = err.message || 'Error al autenticar. Inténtalo de nuevo.';
                setUsernameError(loginError); 
                setPasswordError(loginError); 
                setError(loginError); 
                setDialogStep(1); 
                return; 
            } finally {
                setIsButtonDisabled(true); 
            }
        } else {
            return
        };
    };

    const handleClose = () => {
        setOpenSnack(false);
    };
    const handleReasignFinish = () => {
        setOpenFinalizar(false);
        setDialogStep(1);
        setUsername('');
        setPassword('');
        setIsButtonDisabled(false)
        setUsernameError(null);
        setPasswordError(null);
        setMensaje('Llamada reasignada satisfactoriamente');
        setTipoMensaje('success');
        setOpenSnack(true);
        setTimeout(() => fetchLlamadasActivas(true), 500);
    };

    const handleEscalar = async (idLlamada) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Llamadas/EscalarLlamada`, {
            method: 'POST',
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                idLlamada,
            }),
        });

        if (response.ok) {
            setMensaje('Falla escalada satisfactoriamente');
            setTipoMensaje('success');
            setOpenSnack(true);
            setOpenFinalizar(false);
            setDialogStep(1);
            setUsername('');
            setPassword('');
            setUsernameError(null);
            setPasswordError(null);
            setIsButtonDisabled(false);
            setTimeout(() => fetchLlamadasActivas(true), 500);
        } else {
            throw new Error('Error al procesar la solicitud.');
        }
    } catch (err) {
        setError(err.message || 'Error al escalar la llamada.');
    }

    };

    const handleFinalizar = async (idLlamada, falla, requiereClasificacion, comentario) => {
        if (requiereClasificacion){
            try {
                const response = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Llamadas/ClasificarLlamada`, {
                    method: 'POST',
                    headers: {
                        authorization: `Bearer ${tokenSessionObject.token}`,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        idLlamada,
                        falla,
                        comentario,
                    }),
                });

                if (!response.ok) {
                    const errorBody = await response.text();
                    throw new Error(`Error ${response.status}: ${errorBody}`);
                } else {
                    setOpenFinalizar(false);
                    setDialogStep(1);
                    setUsername('');
                    setPassword('');
                    setUsernameError(null);
                    setPasswordError(null);
                    setShowPasswordForm(false);
                    setMensaje('Llamada finalizada satisfactoriamente');
                    setTipoMensaje('success');
                    setOpenSnack(true);
                    setSelectedOption1('');
                    setSelectedOption2('');
                    setComentario('');
                    setIsButtonDisabled(false);
                    setTimeout(() => fetchLlamadasActivas(true), 500);
                    return
                }
            } catch (err) {
                setMensaje(err.message || 'Error al finalizar la llamada.');
                setTipoMensaje('error');
                setOpenSnack(true);
            }
        } else {
            try {
                const response = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Llamadas/LlamadaFinalizada`, {
                    method: 'POST',
                    headers: {
                        authorization: `Bearer ${tokenSessionObject.token}`,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        idLlamada,
                    }),
                });

                if (!response.ok) {
                    const errorBody = await response.text();
                    throw new Error(`Error ${response.status}: ${errorBody}`);
                } else {
                    setUsernameError(null);
                    setPasswordError(null);
                    setOpenFinalizar(false);
                    setDialogStep(1);
                    setUsername('');
                    setPassword('');
                    setShowPasswordForm(false);
                    setMensaje('Llamada finalizada satisfactoriamente');
                    setTipoMensaje('success');
                    setOpenSnack(true);
                    setIsButtonDisabled(false);
                    setTimeout(() => fetchLlamadasActivas(true), 500);
                    return;
                }
            } catch (err) {
                setMensaje(err.message || 'Error al finalizar la llamada.');
                setTipoMensaje('error');
                setOpenSnack(true);
            }
        }
    }

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const tokenSessionObject = JSON.parse(sessionStorage.getItem('token'));
    const celda = cookie.get('celda');

    const fetchLlamadasActivas = useCallback(async (silent = false) => {
        if (!tokenSessionObject?.token) return;

        if (!silent) setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/ListaLlamados/LlamadasActivas?linea=${linea}&celda=${celda}`, {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                const data = await response.json();
                const datosFiltrados = filtrarDatos(data);
                setRowsANDON(datosFiltrados);
            } else if (response.status === 404) {
                setRowsANDON([]);
            }
        } catch (error) {
        } finally {
            if (!silent) setIsLoading(false);
        }
    }, [tokenSessionObject?.token, linea, celda, filtrarDatos]);

    // Cargar datos iniciales solo una vez
    useEffect(() => {
        if (tokenSessionObject?.token) {
            fetchLlamadasActivas();
        }
    }, [tokenSessionObject?.token, fetchLlamadasActivas]);

    // Intervalo para actualizar datos cada 15 segundos (en lugar de en cada render)
    useEffect(() => {
        if (!tokenSessionObject?.token) return;

        const interval = setInterval(() => {
            fetchLlamadasActivas(true);
        }, 10000); // 15 segundos en lugar de ejecutarse en cada render

        return () => clearInterval(interval);
    }, [tokenSessionObject?.token, fetchLlamadasActivas]);

    // Mantiene el handler siempre fresco con el último estado (open, openFinalizar, idLlamada…)
    // sin necesidad de reconectar el hub en cada render.
    dialogHandlerRef.current = async (data) => {
        const usuario = typeof data === 'string' ? data : (data?.usuario ?? data?.userName ?? data?.user);
        if (!usuario || typeof usuario !== 'string') return;

        if (open) {
            // Flujo Atender: autenticar con tarjeta y marcar la llamada como atendida
            setAuth(true);
            setQuienAtiende(usuario);
            await handleAtender(idLlamada, usuario);
            setAuth(false);
            setOpen(false);
            setIsButtonDisabled(false);
            setUsername('');
            setPassword('');
            setUsernameError(null);
            setPasswordError(null);
            setMensaje('Se inicia reparación');
            setTipoMensaje('success');
            setOpenSnack(true);
            setTimeout(() => fetchLlamadasActivas(true), 500);
        } else if (openFinalizar) {
            // Flujo Finalizar: autenticar con tarjeta y avanzar al paso de clasificación
            setUsername(usuario);
            setAuthFinalizar(true);
            setDialogStep(2);
        }
    };

    // Hub Atender/Finalizar: activo mientras algún diálogo esté abierto.
    // TODO (lunes): confirmar nombre del hub con backend → reemplazar '/llamadasAndon'
    useEffect(() => {
        if (!open && !openFinalizar) {
            if (llamadasHubRef.current) {
                llamadasHubRef.current.stop();
                llamadasHubRef.current = null;
            }
            return;
        }

        const cookie = new Cookies();
        const celdaId = parseInt(cookie.get('celda'));

        const apiBase = process.env.REACT_APP_SERVICE_ENDPOINT_NE || '';
        const hubUrl = apiBase.replace('/api', '/HubNovaEngine');

        const connection = new HubConnectionBuilder()
            .withUrl(hubUrl, { skipNegotiation: true, transport: HttpTransportType.WebSockets })
            .withAutomaticReconnect()
            .build();

        connection.on('RecibirUserCard', (data) => {
            if (dialogHandlerRef.current) dialogHandlerRef.current(data);
        });

        connection.start()
            .then(() => {
                connection.invoke('SuscribirUserCard', celdaId.toString()).catch(() => {});
            })
            .catch(() => {});
        llamadasHubRef.current = connection;

        return () => {
            connection.stop();
            llamadasHubRef.current = null;
        };
    }, [open, openFinalizar]); // eslint-disable-line react-hooks/exhaustive-deps

    // Ref que indica si hay llamadas activas, sin causar re-renders
    const hasActiveTimersRef = useRef(false);
    useEffect(() => {
        hasActiveTimersRef.current = rowsANDON.some(row => row.estatus === 1 || row.estatus === 2);
    }, [rowsANDON]);

    // Timer único de 1 segundo — deps vacías para que el polling no lo reinicie
    useEffect(() => {
        const interval = setInterval(() => {
            if (hasActiveTimersRef.current) {
                setElapsedTime(prev => prev + 1);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (dialogStep === 2 && selectedRow?.requiereClasificacion) {
            const fetchCategories = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/categorias`, {
                        method: 'GET',
                        headers: {
                            authorization: `Bearer ${tokenSessionObject.token}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const data = await response.json();
                    const categoriaYNombre = data.map((item) => ({
                        categoria: item.categoria,
                        nombre: item.nombre,
                    }));
                    setCategorias(categoriaYNombre);
                } catch (error) {
                }
            };

            const fetchOptions = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/fallas`, {
                        method: 'GET',
                        headers: {
                            authorization: `Bearer ${tokenSessionObject.token}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const data = await response.json();
                    const idYNombre = data.map((item) => ({
                        idFalla: item.idFalla,
                        idCategoria: item.idCategoria,
                        categoria: item.categoria,
                        nombre: item.nombre,
                    }));

                    setFallas(idYNombre);

                    if (selectedOption1) {
                        const filtradas = idYNombre.filter((falla) => falla.idCategoria === selectedOption1);
                        setFallasFiltradas(filtradas);

                        if (filtradas.length > 0) {
                            setSelectedOption2(filtradas[0].idFalla);
                        }
                    }
                } catch (error) {
                }
            };

            const fetchData = async () => {
                await Promise.all([fetchOptions(), fetchCategories()]);
            };
            fetchData();
        }
    }, [dialogStep, selectedRow?.requiereClasificacion, tokenSessionObject.token, selectedOption1, setFallas]);

    useEffect(() => {
        if ([2, 3, 4].includes(dialogStep)) {
            setIsButtonDisabled(true);
        }
    }, [dialogStep]); 

    const setRowEvent = async (rowInfo) => {
        return {
            idLlamada: rowInfo.id,
            quienAtiende: rowInfo.atiende,
            quienRecibe: rowInfo.solicita,
            celda: cookie.get('celda'),
            solicita: rowInfo.solicita,
        }
    };

    if (!tokenSessionObject || !linea) {
        return(<div>loading</div>)
    } else {
        const tableColumns = [
            {
                field: 'codigoArea',
                headerName: 'Area',
                flex: 1.3,
                headerAlign: 'center',
                align: 'center',
                renderCell: renderArea,
                sortable: false,
            },
            {
                field: 'nombre',
                headerName: 'Nombre',
                flex: 2,
                align: 'center',
                headerAlign: 'center',
                sortable: false,
            },
            {
                field: 'estatus',
                headerName: 'Estatus',
                flex: 1.6,
                align: 'center',
                headerAlign: 'center',
                renderCell: renderStatus,
                sortable: false,
            },
            {
                field: 'nivel',
                headerName: 'Nivel',
                flex: 1.3,
                headerAlign: 'center',
                align: 'center',
                sortable: false,
            },
            {
                field: 'fechaHoraInicio',
                headerName: 'Inicio',
                flex: 1.6,
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: (params) => {
                    if (!params.value) return "-"; 

                    const date = new Date(params.value);
                    let hours = date.getHours();
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    const seconds = String(date.getSeconds()).padStart(2, '0');
                    const ampm = hours >= 12 ? 'PM' : 'AM';

                    hours = hours % 12 || 12;

                    return <span>{`${hours}:${minutes}:${seconds} ${ampm}`}</span>;
                },
            },
            {
                field: 'tiempoRespuesta',
                headerName: 'T. Respuesta',
                sortable: false,
                flex: 2.5, 
                renderCell: (params) => {
                    if(params.row.estatus === 1){
                        const now = new Date().getTime();
                        const startTime = params.row.fechaHoraInicio?.getTime() ?? now;
                        const elapsed = Math.floor((now - startTime) / 1000);
            
                        const hours = String(Math.floor(elapsed / 3600)).padStart(2, '0');
                        const minutes = String(Math.floor((elapsed % 3600) / 60)).padStart(2, '0');
                        const seconds = String(elapsed % 60).padStart(2, '0');
                        return <span>{`${hours}:${minutes}:${seconds}`}</span>;
                    } else if(params.row.estatus === 2 || params.row.estatus === 3){
                        const totalSeconds = Math.floor(params.row.tiempoRespuesta * 60);
                        const hours = Math.floor(totalSeconds / 3600); 
                        const minutes = Math.floor((totalSeconds % 3600) / 60); 
                        const seconds = totalSeconds % 60; 
            
                        return <span>{`${hours}:${minutes}:${seconds}`}</span>;
                    } else {
                        return "-"; 
                    }
                },
                align: 'center',
                headerAlign: 'center',
            },
            {
                field: 'tiempoReparacion',
                headerName: 'T. Reparación',
                flex: 2.5,
                renderCell: (params) => {

                    if(params.row.estatus === 2){
                        const now = new Date().getTime();
                        const startTime = params.row.fechaHoraRespuesta?.getTime() ?? now;
                        const elapsed = Math.floor((now - startTime) / 1000);
            
                        const hours = String(Math.floor(elapsed / 3600)).padStart(2, '0');
                        const minutes = String(Math.floor((elapsed % 3600) / 60)).padStart(2, '0');
                        const seconds = String(elapsed % 60).padStart(2, '0');
                        return <span>{`${hours}:${minutes}:${seconds}`}</span>;
                    } else if(params.row.estatus === 1 || params.row.estatus === 3){
                        // Si tiempoReparacion es null, calcular tiempo transcurrido desde fechaHoraRespuesta
                        if (!params.row.tiempoReparacion || params.row.tiempoReparacion === null) {
                            if (!params.row.fechaHoraRespuesta) {
                                return <span>00:00:00</span>;
                            }
                            const now = new Date().getTime();
                            const startTime = params.row.fechaHoraRespuesta?.getTime() ?? now;
                            const elapsed = Math.floor((now - startTime) / 1000);
                            const safeElapsed = Math.max(0, elapsed);
                            
                            const hours = Math.floor(safeElapsed / 3600);
                            const minutes = Math.floor((safeElapsed % 3600) / 60);
                            const seconds = safeElapsed % 60;
                            
                            return <span>{`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`}</span>;
                        }
                        
                        const totalSeconds = Math.floor(params.row.tiempoReparacion * 60);
                        const safeTotalSeconds = Math.max(0, totalSeconds);
                        const hours = Math.floor(safeTotalSeconds / 3600); 
                        const minutes = Math.floor((safeTotalSeconds % 3600) / 60); 
                        const seconds = safeTotalSeconds % 60; 
            
                        return <span>{`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`}</span>;
                    } else {
                        return "-"; 
                    }
                },
                align: 'center',
                headerAlign: 'center',
                sortable: false,
            },
            {
                field: 'acciones',
                headerName: 'Acciones',
                flex: 2,
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: (params) => {
                    const estatusText = params.row.estatusText; 
                    if (estatusText === 'Activa') {
                        return (
                            <Button
                                variant="contained"
                                className="table-button"
                                color="primary"
                                onClick={() => {
                                    handleFlujoLoginYAtender()
                                    setIdLlamada(params.row.id); 
                                }}
                                disabled={isButtonDisabled}
                            >
                                <h4 className="table-button-text">Atender</h4>
                            </Button>
                        );
                    } else if (estatusText === 'Reparando') {
                        return (
                            <Button
                                variant="contained"
                                className="table-button"
                                color="primary"
                                onClick={() => {
                                    handleFlujoLoginFinalizar()
                                    setSelectedRow(params.row);
                                    setIdLlamada(params.row.id); 
                                    setRowEvent(params.row)
                                }}                                
                                disabled={isButtonDisabled}
                            >
                                <h4 className="table-button-text">Finalizar</h4>
                            </Button>
                        );
                    } else {
                        return (
                            <Button
                                variant="contained"
                                className="table-button"
                                color="primary"
                                onClick={() => {
                                    handleFlujoLoginYAtender()
                                    setIdLlamada(params.row.id); 
                                }}                                
                                disabled={true}
                            >
                                <h4 className="table-button-text">No action</h4>
                            </Button>
                        );
                    }
                },
            }
        ];

        const areaClassMap = {
            1: 'parosView-table-area3', // verde
            2: 'parosView-table-area1', // rojo
            3: 'parosView-table-area2', // amarillo
            4: 'parosView-table-area4', // azul
        };

        function renderArea(params) {
            const iniciales = params.row.inicialesArea || '?';
            const className = areaClassMap[params.row.colorArea] || 'parosView-table-areaS';
            return (
                <div className={className}>
                    <h1>{iniciales}</h1>
                </div>
            );
        }

        function renderStatus(params) {
            switch (params.value) {
                case 1:
                    return <YellowChip label="Activa" />;
                case 2:
                    return <RedChip label="Reparando" />;
                case 3:
                    return <GreenChip label="Completada" />;
                default:
                    return null;
            }
        }

        function CustomNoRowsOverlay() {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h6" color="textSecondary">
                        {isLoading ? 'Cargando llamadas ANDON...' : 'No hay llamadas ANDON activas'}
                    </Typography>
                </Box>
            );
        }

        return (
            <div className={classes.root}>
                <DataGrid
                    disableColumnFilter
                    disableDensitySelector
                    disableColumnMenu
                    checkboxSelection={false}
                    columns={tableColumns.map(column => ({
                        ...column,
                        sortable: true,
                    }))}
                    localeText={esES.props.MuiDataGrid.localeText}
                    rows={rowsANDON}
                    onSelectionModelChange={(newSelectionModel) => {
                        setSeleccionFila(newSelectionModel);
                    }}
                    selectionModel={seleccionFila}
                    hideFooterPagination={true}
                    hideFooter={true}
                    components={{
                        NoRowsOverlay: CustomNoRowsOverlay,
                    }}
                />
            
                <Dialog
                    open={open}
                    className="andon-dialog"
                    onClose={() => {
                        setOpen(false);
                        setAuth(false);
                        setIsButtonDisabled(false);
                        setShowPasswordForm(false);
                        setUsername('');
                        setPassword('');
                        setUsernameError(false);
                        setPasswordError(false);
                    }}
                >
                    <DialogTitle disableTypography>
                        <div className="andon-dialog-title-row">
                            <span className="andon-dialog-title-text">Se requiere identificación</span>
                            <IconButton
                                className="andon-dialog-title-close"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                    setAuth(false);
                                    setIsButtonDisabled(false);
                                    setShowPasswordForm(false);
                                    setUsername('');
                                    setPassword('');
                                    setUsernameError(false);
                                    setPasswordError(false);
                                }}
                            >
                                <Close fontSize="small" />
                            </IconButton>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        {!showPasswordForm ? (
                            <div className="andon-rfid-screen">
                                <div className="andon-rfid-icon-wrap">
                                    <Nfc className="andon-rfid-icon" />
                                </div>
                                <p className="andon-rfid-title">Acerca tu tarjeta RFID</p>
                                <p className="andon-rfid-subtitle">Esperando lectura del lector...</p>
                                <div className="andon-rfid-divider">
                                    <span className="andon-rfid-divider-line" />
                                    <span className="andon-rfid-divider-text">o si prefieres</span>
                                    <span className="andon-rfid-divider-line" />
                                </div>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    className="andon-rfid-alt-btn"
                                    onClick={() => setShowPasswordForm(true)}
                                >
                                    Acceder con usuario y contraseña
                                </Button>
                            </div>
                        ) : (
                            <>
                                <TextField
                                    label="Nombre de usuario"
                                    variant="standard"
                                    fullWidth
                                    margin="normal"
                                    value={username}
                                    onChange={(e) => { setUsername(e.target.value); setUsernameError(false); }}
                                    error={!!usernameError}
                                    helperText={usernameError ? 'El nombre de usuario es obligatorio' : ''}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton disableRipple tabIndex={-1} className="andon-static-icon">
                                                    <PersonOutline />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <TextField
                                    label="Contraseña"
                                    type={showPassword ? 'text' : 'password'}
                                    variant="standard"
                                    fullWidth
                                    margin="normal"
                                    value={password}
                                    onChange={(e) => { setPassword(e.target.value); setPasswordError(false); }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={togglePasswordVisibility}>
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    error={!!passwordError}
                                    helperText={passwordError ? 'La contraseña es obligatoria' : ''}
                                />
                            </>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={() => {
                                setOpen(false);
                                setAuth(false);
                                setIsButtonDisabled(false);
                                setShowPasswordForm(false);
                                setUsername('');
                                setPassword('');
                                setUsernameError(false);
                                setPasswordError(false);
                            }}
                        >
                            Cancelar
                        </Button>
                        {showPasswordForm && (
                            <Button onClick={handleLogin} color="primary" variant="contained">
                                Iniciar sesión
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openFinalizar}
                    className="andon-dialog"
                    onClose={() => {
                        setOpenFinalizar(false);
                        setDialogStep(1);
                        setUsername('');
                        setPassword('');
                        setIsButtonDisabled(false);
                        setShowPasswordForm(false);
                    }}
                >
                    <DialogTitle disableTypography>
                        <div className="andon-dialog-title-row">
                            <span className="andon-dialog-title-text">
                                {dialogStep === 1 && 'Se requiere identificación de quien aprueba la reparación'}
                                {dialogStep === 2 && 'Información de reparación'}
                                {dialogStep === 3 && 'Confirmación'}
                                {dialogStep === 4 && 'Reasignar llamada'}
                            </span>
                            <IconButton
                                className="andon-dialog-title-close"
                                size="small"
                                onClick={() => {
                                    setOpenFinalizar(false);
                                    setDialogStep(1);
                                    setUsername('');
                                    setPassword('');
                                    setIsButtonDisabled(false);
                                    setShowPasswordForm(false);
                                }}
                            >
                                <Close fontSize="small" />
                            </IconButton>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        {dialogStep === 1 && (
                            <>
                                {!showPasswordForm ? (
                                    <div className="andon-rfid-screen">
                                        <div className="andon-rfid-icon-wrap">
                                            <Nfc className="andon-rfid-icon" />
                                        </div>
                                        <p className="andon-rfid-title">Acerca tu tarjeta RFID</p>
                                        <p className="andon-rfid-subtitle">Esperando lectura del lector...</p>
                                        <div className="andon-rfid-divider">
                                            <span className="andon-rfid-divider-line" />
                                            <span className="andon-rfid-divider-text">o si prefieres</span>
                                            <span className="andon-rfid-divider-line" />
                                        </div>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            fullWidth
                                            onClick={() => setShowPasswordForm(true)}
                                        >
                                            Acceder con usuario y contraseña
                                        </Button>
                                    </div>
                                ) : (
                                    <>
                                        <TextField
                                            label="Nombre de usuario"
                                            variant="standard"
                                            fullWidth
                                            margin="normal"
                                            value={username}
                                            onChange={(e) => { setUsername(e.target.value); setUsernameError(null); }}
                                            error={!!usernameError}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton disableRipple tabIndex={-1} className="andon-static-icon">
                                                            <PersonOutline />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        {usernameError && <p className="andon-dialog-error-text">{usernameError}</p>}
                                        <TextField
                                            label="Contraseña"
                                            type={showPassword ? 'text' : 'password'}
                                            variant="standard"
                                            fullWidth
                                            margin="normal"
                                            value={password}
                                            onChange={(e) => { setPassword(e.target.value); setPasswordError(null); }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={togglePasswordVisibility}>
                                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            error={!!passwordError}
                                        />
                                        {passwordError && <p className="andon-dialog-error-text">{passwordError}</p>}
                                    </>
                                )}
                            </>
                        )}
                        {dialogStep === 2 && (
                            <>
                                {selectedRow.requiereClasificacion ? (
                                    <>
                                        <FormControl variant="standard" fullWidth margin="normal">
                                            <InputLabel>Categoría</InputLabel>
                                            <Select
                                                value={selectedOption1}
                                                onChange={(e) => setSelectedOption1(e.target.value)}
                                            >
                                                {categorias.map((option) => (
                                                    <MenuItem key={option.categoria} value={option.categoria}>
                                                        {option.nombre}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl variant="standard" fullWidth margin="normal">
                                            <InputLabel>Tipo de falla</InputLabel>
                                            <Select
                                                value={selectedOption2}
                                                onChange={(e) => setSelectedOption2(e.target.value)}
                                                disabled={!selectedOption1}
                                            >
                                                {fallasFiltradas.map((falla) => (
                                                    <MenuItem key={falla.idFalla} value={falla.idFalla}>
                                                        {falla.nombre}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <TextField
                                            variant="outlined"
                                            multiline
                                            minRows={3}
                                            fullWidth
                                            margin="normal"
                                            label="Comentarios"
                                            value={comentario}
                                            onChange={(e) => setComentario(e.target.value)}
                                            className="andon-comentarios-field"
                                        />
                                    </>
                                ) : (
                                    <div className="andon-repair-info">
                                        <div className="andon-repair-info-row">
                                            <PersonOutline className="andon-repair-info-icon" />
                                            <div>
                                                <p className="andon-repair-info-label">Técnico asignado</p>
                                                <p className="andon-repair-info-value">{selectedRow.atiende || '—'}</p>
                                            </div>
                                        </div>
                                        <div className="andon-repair-info-row">
                                            <PersonOutline className="andon-repair-info-icon" />
                                            <div>
                                                <p className="andon-repair-info-label">Acepta la reparación</p>
                                                <p className="andon-repair-info-value">{selectedRow.solicita || '—'}</p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        {dialogStep === 3 && (
                            <div className="andon-confirm-screen">
                                <CheckCircleOutline className="andon-confirm-icon" />
                                <p className="andon-confirm-text">
                                    ¿Confirmas que la reparación ha sido completada?
                                </p>
                            </div>
                        )}
                        {dialogStep === 4 && (
                            <>
                                <Typography variant="body2" gutterBottom>
                                    Seleccione la nueva llamada
                                </Typography>
                                <div className="andon-dialog-reassign-container">
                                    <Llamados rowData={{
                                        data: {
                                            idLlamada: selectedRow.id,
                                            quienAtiende: selectedRow.atiende,
                                            quienRecibe: selectedRow.solicita,
                                            celda: cookie.get('celda'),
                                            solicita: selectedRow.solicita,
                                        },
                                        callback: handleReasignFinish,
                                    }} />
                                </div>
                            </>
                        )}
                    </DialogContent>
                    <DialogActions>
                        {dialogStep === 1 && (
                            <>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setOpenFinalizar(false);
                                        setDialogStep(1);
                                        setUsername('');
                                        setPassword('');
                                        setIsButtonDisabled(false);
                                        setUsernameError(null);
                                        setPasswordError(null);
                                        setShowPasswordForm(false);
                                    }}
                                >
                                    Cancelar
                                </Button>
                                {showPasswordForm && (
                                    <Button onClick={handleLogin} color="primary" variant="contained">
                                        Siguiente
                                    </Button>
                                )}
                            </>
                        )}
                        {dialogStep === 2 && (
                            <>
                                {!selectedRow.requiereClasificacion && (
                                    <>
                                        <Button
                                            color="secondary"
                                            variant="outlined"
                                            onClick={() => { setDialogStep(4); setIsButtonDisabled(true); }}
                                        >
                                            Reasignar
                                        </Button>
                                        <Button
                                            color="primary"
                                            variant="outlined"
                                            onClick={() => handleEscalar(selectedRow.id)}
                                        >
                                            Escalar
                                        </Button>
                                    </>
                                )}
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setOpenFinalizar(false);
                                        setDialogStep(1);
                                        setUsername('');
                                        setPassword('');
                                        setUsernameError(null);
                                        setPasswordError(null);
                                        setIsButtonDisabled(false);
                                    }}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={() => setDialogStep(3)}
                                    disabled={selectedRow?.requiereClasificacion && (!selectedOption1 || !selectedOption2 || !comentario.trim())}
                                >
                                    Finalizar
                                </Button>
                            </>
                        )}
                        {dialogStep === 3 && (
                            <>
                                <Button onClick={() => setDialogStep(2)} color="secondary" variant="outlined">
                                    Atrás
                                </Button>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={() => handleFinalizar(selectedRow.id, selectedOption2, selectedRow.requiereClasificacion, comentario)}
                                >
                                    Aceptar reparación
                                </Button>
                            </>
                        )}
                        {dialogStep === 4 && (
                            <Button
                                onClick={() => setDialogStep(2)}
                                color="secondary"
                                variant="outlined"
                            >
                                Regresar
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>

                <ActionToast
                    open={openSnack}
                    message={mensaje}
                    severity={tipoMensaje}
                    duration={3000}
                    onClose={handleClose}
                />
            </div>
        );
    }
}
